export const VIEW_ORDER_BUTTON_TEXT = {
    id: 'oe.salesforceOrder.viewOrder',
    description: 'Control on the event page that opens the linked Salesforce Order details',
    defaultMessage: 'View Order',
};

export const NO_ORDER_TEXT = {
    id: 'oe.salesforceOrder.noOrder',
    description: 'Indicator shown on the event page when no Salesforce Order is linked',
    defaultMessage: 'No Order',
};

export const MODAL_TITLE = {
    id: 'oe.salesforceOrder.modalTitle',
    description: 'Salesforce Order details modal title',
    defaultMessage: 'Salesforce Order',
};

export const LOADING_TEXT = {
    id: 'oe.salesforceOrder.loading',
    description: 'Loading text while fetching the Salesforce Order',
    defaultMessage: 'Loading order details...',
};

export const ERROR_TITLE = {
    id: 'oe.salesforceOrder.errorTitle',
    description: 'Title for the Salesforce unavailability state on the order view',
    defaultMessage: 'Salesforce is temporarily unavailable',
};

export const ERROR_MESSAGE = {
    id: 'oe.salesforceOrder.errorMessage',
    description: 'Body for the Salesforce unavailability state on the order view',
    defaultMessage: 'We couldn\'t load the order details right now. The rest of the event page is unaffected — please try again later.',
};


export const NO_ORDER_LINKED_TEXT = {
    id: 'oe.salesforceOrder.noOrderLinked',
    description: 'Shown when the order id is not linked to an order in Salesforce and no message is returned',
    defaultMessage: 'Order id not linked in Salesforce',
};

export const EDIT_ORDER_BUTTON_TEXT = {
    id: 'oe.salesforceOrder.editOrder',
    description: 'Edit Order button in the read-only Salesforce Order modal that opens the Edit Order form',
    defaultMessage: 'Edit Order',
};

export const EDIT_MODAL_TITLE = {
    id: 'oe.salesforceOrder.editModalTitle',
    description: 'Edit Salesforce Order form title; {orderNumber} is the OE order number',
    defaultMessage: 'Edit Salesforce Order : OE {orderNumber}',
};

export const SF_ORDER_NUMBER_LABEL = {
    id: 'oe.salesforceOrder.summary.orderNumber',
    description: 'Read-only Salesforce Order # label in the Edit Order form summary panel',
    defaultMessage: 'Salesforce Order #',
};

export const ORDER_UPDATED_TEXT = {
    id: 'oe.salesforceOrder.orderUpdated',
    description: 'Success toast shown after editing a Salesforce order',
    defaultMessage: 'Salesforce order updated',
};

export const ORDER_UPDATE_ERROR_TEXT = {
    id: 'oe.salesforceOrder.updateError',
    description: 'Error shown in the Edit Salesforce Order modal when the update call fails or times out',
    defaultMessage: 'We couldn\'t save your changes. Please try again.',
};

export const ADD_ORDER_BUTTON_TEXT = {
    id: 'oe.salesforceOrder.addOrder',
    description: 'Control on the event page that opens the Add Salesforce Order form (users with Create Order permission)',
    defaultMessage: '+ Add Order',
};

export const ADD_MODAL_TITLE = {
    id: 'oe.salesforceOrder.addModalTitle',
    description: 'Add Salesforce Order form title',
    defaultMessage: 'Add Salesforce Order',
};

export const ORDER_SAVE_WARNING_TITLE = {
    id: 'oe.salesforceOrder.saveWarningTitle',
    description: 'Alert title shown above the View Order popup when the order was saved but the create/update API response included a warningMessage (e.g. a Project Manager could not be matched to a Salesforce user)',
    defaultMessage: 'Salesforce Order saved with a warning',
};

export const GROUP_CREATE_ORDER = {
    id: 'oe.salesforceOrder.group.createOrder',
    description: 'Create Order group heading (clone, link, or manual choice) on the Add Salesforce Order form',
    defaultMessage: 'Create Order',
};

export const CLONE_EXISTING_ORDER_OPTION_TEXT = {
    id: 'oe.salesforceOrder.creationMode.clone',
    description: 'Radio option on the Add Salesforce Order form to clone an existing order',
    defaultMessage: 'Clone Existing Order',
};

export const LINK_EXISTING_ORDER_OPTION_TEXT = {
    id: 'oe.salesforceOrder.creationMode.link',
    description: 'Radio option on the Add Salesforce Order form to link an existing Salesforce order to this event',
    defaultMessage: 'Link to Existing Order',
};

export const CREATE_ORDER_MANUALLY_OPTION_TEXT = {
    id: 'oe.salesforceOrder.creationMode.manual',
    description: 'Radio option on the Add Salesforce Order form to fill the form out manually',
    defaultMessage: 'Create Order Manually',
};

export const EXISTING_ORDER_LABEL = {
    id: 'oe.salesforceOrder.existingOrder.label',
    description: 'Label for the existing-order search field used by Clone and Link on the Add Salesforce Order form',
    defaultMessage: 'Existing Order',
};

export const EXISTING_ORDER_CLONE_ERROR_TEXT = {
    id: 'oe.salesforceOrder.existingOrder.cloneError',
    description: 'Shown when the selected order\'s details fail to load while cloning into a new order',
    defaultMessage: 'We couldn\'t load that order. Please try again.',
};

export const EXISTING_ORDER_LINK_LOAD_ERROR_TEXT = {
    id: 'oe.salesforceOrder.existingOrder.linkLoadError',
    description: 'Shown when the selected order\'s details fail to load while linking an existing order',
    defaultMessage: 'We couldn\'t load that order. Please try again.',
};

export const EXISTING_ORDER_REQUIRED_MESSAGE = {
    id: 'oe.validation.required.message',
    defaultMessage: '{fieldName} is required.',
};

export const HIGH_PROFILE_REASONING_REQUIRED_MESSAGE = {
    id: 'oe.salesforceOrder.highProfileReasoningRequired',
    description: 'Validation message shown when High Profile Order is checked and High Profile Reasoning is left blank',
    defaultMessage: 'When the High Profile checkbox is selected, please populate a reason.',
};

export const EXISTING_ORDER_ALREADY_LINKED_MESSAGE = {
    id: 'oe.salesforceOrder.existingOrder.alreadyLinked',
    description: 'Shown under Existing Order in Link mode when the selected Salesforce order is already linked to an OE Central event',
    defaultMessage: 'Order is already linked with an event.',
};

export const ADD_ORDER_VALIDATION_MESSAGE = {
    id: 'oe.salesforceOrder.addValidationMessage',
    description: 'Footer message shown on the Add Salesforce Order form when required fields are missing',
    defaultMessage: '* You must fill in all required fields to add a Salesforce order.',
};

export const ORDER_ADDED_TEXT = {
    id: 'oe.salesforceOrder.orderAdded',
    description: 'Success toast shown after adding a Salesforce order',
    defaultMessage: 'Salesforce order added',
};

export const ORDER_LINKED_TEXT = {
    id: 'oe.salesforceOrder.orderLinked',
    description: 'Success toast shown after linking an existing Salesforce order to the event',
    defaultMessage: 'Salesforce order linked',
};

export const ORDER_CREATE_ERROR_TEXT = {
    id: 'oe.salesforceOrder.createError',
    description: 'Error shown in the Add Salesforce Order modal when the create call fails or times out',
    defaultMessage: 'We couldn\'t create the order. Please try again.',
};

export const ORDER_LINK_ERROR_TEXT = {
    id: 'oe.salesforceOrder.linkError',
    description: 'Error shown in the Add Salesforce Order modal when linking an existing order fails or times out',
    defaultMessage: 'We couldn\'t link the order. Please try again.',
};

export const ADD_ORDER_BUTTON_SUBMIT_TEXT = {
    id: 'oe.salesforceOrder.addSubmit',
    description: 'Submit button on the Add Salesforce Order form',
    defaultMessage: 'Add',
};


export const SUMMARY_BLUEPRINT_LABEL = {
    id: 'oe.salesforceOrder.summary.blueprint',
    description: 'Add order form summary label: Blueprint',
    defaultMessage: 'Blueprint',
};
export const SUMMARY_REGION_LABEL = {
    id: 'oe.salesforceOrder.summary.region',
    description: 'Add order form summary label: Region',
    defaultMessage: 'Region',
};
export const SUMMARY_CLIENT_DEPARTMENT_LABEL = {
    id: 'oe.salesforceOrder.summary.clientDepartment',
    description: 'Add order form summary label: Client Department',
    defaultMessage: 'Client Department',
};
export const SUMMARY_PROJECT_MANAGER_LABEL = {
    id: 'oe.salesforceOrder.summary.projectManager',
    description: 'Add order form summary label: Project Manager',
    defaultMessage: 'Project Manager',
};
export const SUMMARY_PROJECT_MANAGER_2_LABEL = {
    id: 'oe.salesforceOrder.summary.projectManager2',
    description: 'Add order form / View Order summary label: Project Manager 2',
    defaultMessage: 'Project Manager 2',
};

export const FIELD_DESCRIPTION_LABEL = {
    id: 'oe.salesforceOrder.field.description',
    description: 'Salesforce Order field label: Description/Notes',
    defaultMessage: 'Description/Notes',
};

export const FIELD_PRICE_BOOK_LABEL = {
    id: 'oe.salesforceOrder.field.priceBook',
    description: 'Salesforce Order field label: Price Book',
    defaultMessage: 'Price Book',
};

export const FIELD_CURRENCY_LABEL = {
    id: 'oe.salesforceOrder.field.currency',
    description: 'Salesforce Order field label: Currency',
    defaultMessage: 'Currency',
};

export const LOOKUP_PLACEHOLDER_TEXT = {
    id: 'oe.salesforceOrder.lookup.placeholder',
    description: 'Placeholder for the searchable lookup dropdowns on the Add Order form',
    defaultMessage: 'Select...',
};

export const LOOKUP_NO_RESULTS_TEXT = {
    id: 'oe.salesforceOrder.lookup.noResults',
    description: 'Shown in a lookup dropdown when the typed search matches no options',
    defaultMessage: 'No results',
};

export const LOOKUP_SEARCH_PLACEHOLDER_TEXT = {
    id: 'oe.salesforceOrder.lookup.searchPlaceholder',
    description: 'Placeholder for the search box inside a lookup dropdown',
    defaultMessage: 'Search',
};

export const LOOKUP_MIN_CHARS_HINT_TEXT = {
    id: 'oe.salesforceOrder.lookup.minCharsHint',
    description: 'Hint shown in an async lookup before enough characters are typed to search',
    defaultMessage: 'Type {min} or more characters to search',
};

export const LOOKUP_LOADING_TEXT = {
    id: 'oe.salesforceOrder.lookup.loading',
    description: 'Shown while an async lookup search is in progress',
    defaultMessage: 'Searching...',
};

export const LOOKUP_ERROR_TEXT = {
    id: 'oe.salesforceOrder.lookup.error',
    description: 'Shown when an async lookup search fails',
    defaultMessage: 'Search failed. Please try again.',
};

export const LOOKUP_CLEAR_OPTION_TEXT = {
    id: 'oe.salesforceOrder.lookup.clearOption',
    description: 'Blank option in a lookup dropdown that clears the current selection',
    defaultMessage: 'None',
};

export const GROUP_ORDER_DETAILS = {
    id: 'oe.salesforceOrder.group.orderDetails',
    description: 'Order Details group heading',
    defaultMessage: 'Order Details',
};

export const GROUP_INTEGRATION_DETAILS = {
    id: 'oe.salesforceOrder.group.integrationDetails',
    description: 'Integration Details group heading',
    defaultMessage: 'Integration Details',
};

export const GROUP_BILLING = {
    id: 'oe.salesforceOrder.group.billing',
    description: 'Billing group heading',
    defaultMessage: 'Billing',
};

export const GROUP_POST_EVENT = {
    id: 'oe.salesforceOrder.group.postEvent',
    description: 'Post Event group heading',
    defaultMessage: 'Post Event',
};

export const GROUP_DESCRIPTION = {
    id: 'oe.salesforceOrder.group.description',
    description: 'Description/Notes section heading',
    defaultMessage: 'Description/Notes',
};

export const GROUP_PRODUCTS = {
    id: 'oe.salesforceOrder.group.products',
    description: 'Products section heading',
    defaultMessage: 'Products',
};

export const PRODUCTS_EMPTY_TEXT = {
    id: 'oe.salesforceOrder.products.empty',
    description: 'Empty state shown when the order has no products',
    defaultMessage: 'No products on this order',
};

export const PRODUCTS_PRICE_BOOK_LABEL = {
    id: 'oe.salesforceOrder.products.priceBook',
    description: 'Price Book label above the products table',
    defaultMessage: 'Price Book:',
};

export const PRODUCTS_CURRENCY_LABEL = {
    id: 'oe.salesforceOrder.products.currency',
    description: 'Currency label above the products table',
    defaultMessage: 'Currency:',
};

export const PRODUCTS_TOTAL_LABEL = {
    id: 'oe.salesforceOrder.products.totalLabel',
    description: 'Label for the products grand-total row',
    defaultMessage: 'TOTAL',
};

export const PRODUCT_COLUMNS = {
    product: {
        id: 'oe.salesforceOrder.products.column.product',
        description: 'Products table column: product name',
        defaultMessage: 'Product',
    },
    listPrice: {
        id: 'oe.salesforceOrder.products.column.listPrice',
        description: 'Products table column: list price',
        defaultMessage: 'List Price',
    },
    unitPrice: {
        id: 'oe.salesforceOrder.products.column.unitPrice',
        description: 'Products table column: unit price',
        defaultMessage: 'Unit Price',
    },
    notes: {
        id: 'oe.salesforceOrder.products.column.notes',
        description: 'Products table column: notes',
        defaultMessage: 'Notes',
    },
    quantity: {
        id: 'oe.salesforceOrder.products.column.quantity',
        description: 'Products table column: quantity',
        defaultMessage: '#',
    },
    total: {
        id: 'oe.salesforceOrder.products.column.total',
        description: 'Products table column: total',
        defaultMessage: 'Total',
    },
};

export const MANAGE_PRODUCTS_LINK_TEXT = {
    id: 'oe.salesforceOrder.manageProducts.link',
    description: 'Link in the Products section of the Add/Edit Order form that opens the Manage Products modal',
    defaultMessage: 'Manage Products',
};

export const MANAGE_PRODUCTS_NO_PRICE_BOOK_TEXT = {
    id: 'oe.salesforceOrder.manageProducts.noPriceBook',
    description: 'Shown when the user opens Manage Products before a Price Book has been selected (req 4)',
    defaultMessage: 'Please select a Contract with an associated Price Book before managing products.',
};

export const BILLING_LOCKED_NOTICE_TEXT = {
    id: 'oe.salesforceOrder.billingLocked.notice',
    description: 'Explanation shown at the top of the Billing section and near Manage Products when billing/product fields are read-only because the order is with Finance',
    defaultMessage: 'Billing and product details are locked because this order\'s Billing Status is Pending Billing Review or later. Contact Support to request a change.',
};

export const MANAGE_PRODUCTS_MODAL_TITLE = {
    id: 'oe.salesforceOrder.manageProducts.title',
    description: 'Manage Products modal title',
    defaultMessage: 'Manage Products',
};

export const MANAGE_PRODUCTS_SEARCH_PLACEHOLDER = {
    id: 'oe.salesforceOrder.manageProducts.searchPlaceholder',
    description: 'Placeholder for the product-catalogue search box in the Manage Products modal',
    defaultMessage: 'Search products',
};

export const MANAGE_PRODUCTS_SELECTED_SUMMARY_TITLE = {
    id: 'oe.salesforceOrder.manageProducts.selectedSummaryTitle',
    description: 'Heading above the running summary of selected products in the Manage Products modal',
    defaultMessage: 'Selected Products',
};

export const MANAGE_PRODUCTS_SELECTED_EMPTY_TEXT = {
    id: 'oe.salesforceOrder.manageProducts.selectedEmpty',
    description: 'Shown in the left panel when no products are selected yet',
    defaultMessage: 'No products selected yet',
};

export const MANAGE_PRODUCTS_CATALOGUE_EMPTY_TEXT = {
    id: 'oe.salesforceOrder.manageProducts.catalogueEmpty',
    description: 'Empty state when a Price Book / Currency combination returns no products (AC14)',
    defaultMessage: 'No products available for this Price Book and Currency',
};

export const MANAGE_PRODUCTS_LOADING_TEXT = {
    id: 'oe.salesforceOrder.manageProducts.loading',
    description: 'Shown while the product catalogue is loading',
    defaultMessage: 'Loading products...',
};

export const MANAGE_PRODUCTS_ERROR_TEXT = {
    id: 'oe.salesforceOrder.manageProducts.error',
    description: 'Shown when the product catalogue fails to load and can be retried (AC10)',
    defaultMessage: 'We couldn\'t load the products right now. Please try again.',
};

export const MANAGE_PRODUCTS_RETRY_TEXT = {
    id: 'oe.salesforceOrder.manageProducts.retry',
    description: 'Retry button when the product catalogue fails to load',
    defaultMessage: 'Retry',
};

export const MANAGE_PRODUCTS_CURRENCY_WARNING_TITLE = {
    id: 'oe.salesforceOrder.manageProducts.currencyWarningTitle',
    description: 'Title of the confirmation shown before changing currency wipes selected products (AC8 Option A)',
    defaultMessage: 'Change currency?',
};

export const MANAGE_PRODUCTS_CURRENCY_WARNING_MESSAGE = {
    id: 'oe.salesforceOrder.manageProducts.currencyWarningMessage',
    description: 'Body of the change-currency confirmation (AC8 Option A)',
    defaultMessage: 'If you change currency, all your existing Products will be deleted. Do you wish to continue?',
};

export const MANAGE_PRODUCTS_CURRENCY_WARNING_CONFIRM = {
    id: 'oe.salesforceOrder.manageProducts.currencyWarningConfirm',
    description: 'Confirm button for the change-currency warning',
    defaultMessage: 'Yes, change currency',
};

export const MANAGE_PRODUCTS_CANCEL_WARNING_TITLE = {
    id: 'oe.salesforceOrder.manageProducts.cancelWarningTitle',
    description: 'Title of the reconfirm shown when cancelling with unsaved product changes (AC11)',
    defaultMessage: 'Discard changes?',
};

export const MANAGE_PRODUCTS_CANCEL_WARNING_MESSAGE = {
    id: 'oe.salesforceOrder.manageProducts.cancelWarningMessage',
    description: 'Body of the cancel reconfirm (AC11)',
    defaultMessage: 'You have unsaved product changes. Are you sure you want to discard them?',
};

export const MANAGE_PRODUCTS_CANCEL_WARNING_CONFIRM = {
    id: 'oe.salesforceOrder.manageProducts.cancelWarningConfirm',
    description: 'Confirm button for the cancel reconfirm — discards changes',
    defaultMessage: 'Yes, discard',
};

export const MANAGE_PRODUCTS_CANCEL_WARNING_ABORT = {
    id: 'oe.salesforceOrder.manageProducts.cancelWarningAbort',
    description: 'Abort button for the cancel reconfirm — returns to the modal',
    defaultMessage: 'Keep editing',
};

export const MANAGE_PRODUCTS_NOTE_REQUIRED_TEXT = {
    id: 'oe.salesforceOrder.manageProducts.noteRequired',
    description: 'Validation shown when the Unit Price differs from the List Price but no note was added (req 8)',
    defaultMessage: 'Please add a note explaining the price change.',
};

export const MANAGE_PRODUCTS_UNIT_PRICE_INVALID_TEXT = {
    id: 'oe.salesforceOrder.manageProducts.unitPriceInvalid',
    description: 'Validation shown when the Unit Price entered is not a valid number (negative values are allowed)',
    defaultMessage: 'Please enter a valid Unit Price.',
};

export const MANAGE_PRODUCTS_ADD_LINE_ITEM_TEXT = {
    id: 'oe.salesforceOrder.manageProducts.addLineItem',
    description: 'Tooltip on the "+" control that adds another line item for the same product',
    defaultMessage: '+ Add Line Item',
};

export const MANAGE_PRODUCTS_MAX_REACHED_TEXT = {
    id: 'oe.salesforceOrder.manageProducts.maxReached',
    description: 'Shown when the user tries to add more than the maximum number of products (AC12)',
    defaultMessage: 'You can add a maximum of {max} products.',
};

interface IOrderFieldDescriptor {
    key: string;
    label: { id: string; description: string; defaultMessage: string };
    fullWidth?: boolean;
    wide?: boolean;
    startsRow?: boolean;
    preserveWhitespace?: boolean;
    type?: 'placeholder';
}

interface IOrderFieldGroup {
    title: { id: string; description: string; defaultMessage: string };
    columns: number;
    fields: IOrderFieldDescriptor[];
}

const label = (id: string, defaultMessage: string) => ({
    id: `oe.salesforceOrder.field.${id}`,
    description: `Salesforce Order field label: ${defaultMessage}`,
    defaultMessage: defaultMessage,
});

export const FIELD_OEC_EVENT_ID_LABEL = label('oecEventId', 'Event ID');
export const FIELD_OE_CENTRAL_URL_LABEL = label('oeCentralUrl', 'OEC URL');
export const FIELD_OEC_URL_LINK_TEXT = {
    id: 'oe.salesforceOrder.field.oeCentralUrl.linkText',
    description: 'Clickable text shown for the OEC URL value in Link order details',
    defaultMessage: 'event link',
};

export const LINK_PREVIEW_ORDER_FIELDS: IOrderFieldDescriptor[] = [
    { key: 'oecEventId', label: FIELD_OEC_EVENT_ID_LABEL },
    { key: 'oeCentralUrl', label: FIELD_OE_CENTRAL_URL_LABEL, wide: true },
];

export const ORDER_FIELD_GROUPS: IOrderFieldGroup[] = [
    {
        title: GROUP_ORDER_DETAILS,
        columns: 3,
        fields: [
            { key: 'orderStatus', label: label('orderStatus', 'Order Status') },
            { key: 'billingStatus', label: label('billingStatus', 'Billing Status') },
            { key: 'contractNumber', label: label('contractNumber', 'Contract #') },
            { key: 'multiEventOrder', label: label('multiEventOrder', 'Multi Event Order'), startsRow: true },
            { key: 'parentOrder', label: label('parentOrder', 'Parent Order') },
            { key: 'requesterContact', label: label('requesterContact', 'Requester Contact') },
            { key: 'corporateRelated', label: label('corporateRelated', 'Corporate Related') },
            { key: 'orderType', label: label('orderType', 'Order Type') },
            { key: 'orderSubtype', label: label('orderSubtype', 'Order Subtype') },
            { key: 'eventType', label: label('eventType', 'Event Type (OE Defined)') },
            { key: 'eventTypeClient', label: label('eventTypeClient', 'Event Type (Client Defined)') },
            { key: 'channelAgencyReferral', label: label('channelAgencyReferral', 'Channel/Agency Referral') },
            { key: 'highProfileOrder', label: label('highProfileOrder', 'High Profile Order'), startsRow: true },
            { key: 'highProfileReasoning', label: label('highProfileReasoning', 'High Profile Reasoning') },
            { key: 'highProfileAttendeeDetails', label: label('highProfileAttendeeDetails', 'High Profile Attendee Details'), fullWidth: true },
            { key: 'isThisEventRepeatable', label: label('isThisEventRepeatable', 'Is This Event Repeatable') },
            { key: 'accountLegalEntity', label: label('accountLegalEntity', 'Account Legal Entity') },
            { key: 'hybridEvent', label: label('hybridEvent', 'Hybrid Event') },
            { key: 'opportunity', label: label('opportunity', 'Opportunity') },
            { key: 'hostLob', label: label('hostLob', 'Host LOB') },
            { key: 'hostSubLob', label: label('hostSubLob', 'Host Sub LOB') },
            { key: 'feedbackFormUrl', label: label('feedbackFormUrl', 'Feedback Form URL') },
            { key: 'cancellationReason', label: label('cancellationReason', 'Cancellation Reason') },
            { key: 'cancellationFee', label: label('cancellationFee', 'Cancellation Fee?') },
            { key: 'cancellationOther', label: label('cancellationOther', 'Cancellation Other'), fullWidth: true },
        ],
    },
    {
        title: GROUP_INTEGRATION_DETAILS,
        columns: 3,
        fields: [
            { key: 'noStaffRequired', label: label('noStaffRequired', 'No Staffing Required'), startsRow: true },
            { key: 'lassoSyncStatus', label: label('lassoSyncStatus', 'Lasso Sync Status') },
            { key: 'lassoSyncDatetime', label: label('lassoSyncDatetime', 'Lasso Sync Datetime') },
            { key: 'syncToTeams', label: label('syncToTeams', 'Sync to Teams'), startsRow: true },
            { key: 'teamsCreated', label: label('teamsCreated', 'Teams Created') },
            { key: 'processedForArchive', label: label('processedForArchive', 'Teams Channel Archived') },
        ],
    },
    {
        title: GROUP_BILLING,
        columns: 3,
        fields: [
            { key: 'billToLegalEntity', label: label('billToLegalEntity', 'Bill To (Legal Entity)') },
            { key: 'billingAddress', label: label('billingAddress', 'Billing Address'), wide: true },
            { key: 'billingContact', label: label('billingContact', 'Billing Contact') },
            { key: 'billingContactEmail', label: label('billingContactEmail', 'Billing Contact Email'), wide: true },
            { key: 'additionalRecipient1', label: label('additionalRecipient1', 'Additional Recipient 1') },
            { key: 'additionalRecipient1Email', label: label('additionalRecipient1Email', 'Additional Recipient 1 Email'), wide: true },
            { key: 'additionalRecipient2', label: label('additionalRecipient2', 'Additional Recipient 2') },
            { key: 'additionalRecipient2Email', label: label('additionalRecipient2Email', 'Additional Recipient 2 Email'), wide: true },
            { key: 'billingMethod', label: label('billingMethod', 'Billing Method') },
            { key: 'clientCostCode', label: label('clientCostCode', 'Client Cost Code'), wide: true },
            { key: 'secondaryPO', label: label('secondaryPO', 'Secondary PO') },
            { key: 'billingTimeSensitivity', label: label('billingTimeSensitivity', 'Billing Time Sensitivity') },
            { key: 'billingConfirmation', label: label('billingConfirmation', 'Billing Details Confirmation'), wide: true },
            { key: 'billingNotes', label: label('billingNotes', 'Billing Notes'), fullWidth: true },
        ],
    },
    {
        title: GROUP_POST_EVENT,
        columns: 3,
        fields: [
            { key: 'qaChatEnabled', label: label('qaChatEnabled', 'Q&A Chat Enabled') },
            { key: 'qaReportSent', label: label('qaReportSent', 'Q&A Report Sent') },
            { key: 'eventRanSmoothly', label: label('eventRanSmoothly', 'Event Ran Smoothly') },
            { key: 'postEventNotes', label: label('postEventNotes', 'Post Event Notes'), fullWidth: true, preserveWhitespace: true },
        ],
    },
];

export { IOrderFieldDescriptor, IOrderFieldGroup };
